/* Web Application Map */
import React, { lazy } from 'react';
import { Redirect } from 'react-router';
import { Route } from 'react-router-dom';
import Page from 'skrit-web-framework/components/Page';

export const routes = [
    {
        path: '/',
        exact: true,
        component: lazy(() => import('../ventanas/dashboard/Dashboard'))
    },
    {
        path: '/perfil',
        exact: true,
        component: lazy(() => import('../ventanas/perfil/Perfil'))
    },
    {
        path: '/usuarios',
        exact: true,
        component: lazy(() => import('../ventanas/perfil/usuarios/Usuarios'))
    },
    {
        path: '/agenda',
        component: lazy(() => import('../ventanas/agenda/Agenda'))
    },
    {
        path: '/logout',
        component: lazy(() => import('../ventanas/login/logout'))
    },
    {
        path: '/menus-licencias',
        component: lazy(() => import('../ventanas/menus/Menus'))
    },

    {
        path: '/roles-licencias',
        component: lazy(() => import('../ventanas/roles/Roles'))
    },
    {
        path: '/idiomas',
        component: lazy(() => import('../ventanas/idiomas/Idiomas'))
    },

    {
        path: '/menus-motoscat',
        component: lazy(() => import('../ventanas/ecommerce/menus/MenusWeb'))
    },
    {
        path: '/roles-motoscat',
        component: lazy(() => import('../ventanas/ecommerce/roles/RolesWeb'))
    },
    {
        path: '/idiomas-motoscat',
        component: lazy(() =>
            import('../ventanas/ecommerce/idiomas/IdiomasWeb')
        )
    },
    {
        path: '/temas-motoscat',
        component: lazy(() => import('../ventanas/ecommerce/temas/TemasWeb'))
    },
    {
        path: '/usuarios-motoscat',
        component: lazy(() =>
            import('../ventanas/ecommerce/usuarios/UsuariosWeb')
        )
    },
    {
        path: '/motos',
        component: lazy(() => import('../ventanas/motos/Motos'))
    },
    {
        path: '/marcas-motos',
        component: lazy(() => import('../ventanas/motos/marcas/Marcas'))
    },
    ,
    {
        path: '/articulos',
        component: lazy(() => import('../ventanas/articulos/Articulos'))
    },
    {
        path: '/marcas-articulos',
        component: lazy(() => import('../ventanas/articulos/marcas/Marcas'))
    },
    {
        path: '/motos-articulos',
        component: lazy(() => import('../ventanas/articulos/marcas/Marcas'))
    },
    {
        path: '/modelos-motos',
        component: lazy(() => import('../ventanas/catalogo/ModelosMotos'))
    },
    {
        path: '/importacion-bd',
        component: lazy(() => import('../ventanas/catalogo/Importacion'))
    },
    {
        path: '/familias-articulos',
        component: lazy(() => import('../ventanas/catalogo/FamiliasArticulos'))
    }
];

export const RouteWithSubRoutes = route => (
    <Route
        exact={route.exact}
        path={route.path}
        render={props =>
            localStorage.getItem('isLogged') === 'true' ? (
                <Page>
                    <route.component {...props} routes={route.routes} />
                </Page>
            ) : (
                <Redirect to='login' />
            )
        }
    />
);
